<template>
  <v-layout row align-center justify-space-around>
    <v-flex xs12 order-lg2 id="tweetsListings">
      <v-flex xs12>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1" style="position: absolute; left: 5px;">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
      <v-list style="min-height: 100px" three-line class="pt-0 scroll-y" v-if="dataState === 'loading' || dataState === 'ready'" :class="dataState !== 'ready' ? 'blurClass' : ''">
        <v-divider v-if="dataState === 'ready'"></v-divider>
        <template v-for="(item, index) in tweets">
          <v-list-tile
            :key="item._twitter_id"
            avatar
            style="max-width: 100%"
            class='pa-0 afterHeader'
            :style='index % 2 === 0 ? "background-color: #EFEFEF99" : "background-color: #FFFFFF99"'
          >
            <v-flex style="width: calc(30% - 10px)">
              <v-layout row style="flex: none; width: 100%">
                <v-list-tile-avatar @click="goToUser(item._user_screen_name)" class="pointer" style="margin-top: auto; margin-bottom: auto">
                  <img :src="item._user_profile_image_url_https">
                </v-list-tile-avatar>
                <v-list-tile-content style="width: calc(100% - 60px);" class='pr-4 tweets'>
                  <v-list-tile-title @click="goToUser(item._user_screen_name)" class="pointer">{{item._user_name}} <span class="pl-1 caption">{{'@'+item._user_screen_name}}</span></v-list-tile-title>
                  <v-list-tile-sub-title style="max-height:60px" class="pointer" @click="goToTweet(item._twitter_id, item._user_screen_name)">{{ item._text.length > 140 ? item._text.slice(0,140) + '...' : item._text }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-layout>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_user_followers_count' ? 'background-color: #AAAAAA11' : ''">
              <v-list-tile-title class="text-md-center"><v-icon small left class="mr-2" color="gray lighten-2">fas fa-users</v-icon>{{ formatNumber(item._user_followers_count) }}</v-list-tile-title>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_retweet_count' ? 'background-color: #00FF0011' : ''">
              <v-list-tile-title class="text-md-center"><v-icon small left class="mr-2" color="green lighten-2">fas fa-retweet</v-icon>{{ options.latest === true ? formatNumber(item['_retweet_count_latest']) : formatNumber(item._retweet_count) }}</v-list-tile-title>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_favorite_count' ? 'background-color: #FF000011' : ''">
              <v-list-tile-title class="text-md-center"><v-icon small left class="mr-2" color="red lighten-2">fas fa-heart</v-icon>{{ options.latest === true ? formatNumber(item['_favorite_count_latest']) : formatNumber(item._favorite_count) }}</v-list-tile-title>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_reply_count' ? 'background-color: #0000FF11' : ''">
              <v-list-tile-title class="text-md-center"><v-icon small left class="mr-2" color="blue lighten-2">fas fa-comment</v-icon>{{ options.latest === true ? formatNumber(item['_reply_count_latest']) : formatNumber(item._reply_count) }}</v-list-tile-title>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_quote_count' ? 'background-color: #00FFFF11' : ''">
              <v-list-tile-title class="text-md-center"><v-icon small left class="mr-2" color="teal lighten-2">fas fa-quote-right</v-icon>{{ options.latest === true ? formatNumber(item['_quote_count_latest']) : formatNumber(item._quote_count) }}</v-list-tile-title>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters' :style="options.sortBy === '_impression_count' ? 'background-color: #BA68C811' : ''">
              <v-list-tile-title class="text-md-center"><v-icon small left class="mr-2" color="purple lighten-2">fas fa-bullhorn</v-icon>{{ formatNumber(item._impression_count) }}</v-list-tile-title>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-content class='counters align-center' :style="options.sortBy === '_created_at' ? 'background-color: #FFB74D11' : ''">
              <v-layout row class="align-center justify-content-center">
                <v-flex sm2>
                  <v-icon small class="mr-2" color="orange lighten-2">fas fa-calendar</v-icon>
                </v-flex>
                <v-flex>
                  <v-list-tile-title>{{ formatDate(getLocalDate(item._created_at)) }}</v-list-tile-title>
                  <v-list-tile-sub-title v-html="formatTime(getLocalDate(item._created_at))"></v-list-tile-sub-title>
                </v-flex>
              </v-layout>
            </v-list-tile-content>
            <v-divider vertical></v-divider>
            <v-list-tile-avatar @click.stop="backtrack(item._tweet_id, 'tweet', item._created_at)" color="secondary" size="40" class="pointer actions align-center" style="margin-top:0">
              <v-btn icon>
                <v-icon>fas fa-backward</v-icon>
              </v-btn>
            </v-list-tile-avatar>
            <v-divider vertical></v-divider>
            <v-list-tile-avatar @click.stop="selectedTweet = item._tweet_id; deleteTweetConfirmationDialog = true" color="secondary actions align-center" size="40" class="pointer" style="margin-top:0">
              <v-btn icon>
                <v-icon>fas fa-trash</v-icon>
              </v-btn>
            </v-list-tile-avatar>
          </v-list-tile>
        </template>
      </v-list>
      
      <template v-if="dataState === 'loading'">
        <center class="alternateState">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </center>
      </template>
      <template v-else-if="dataState === 'noData'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
      </template>
      <template v-else-if="dataState === 'error'">
        <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
      </template>
      <v-flex xs12>
        <v-btn style="position: absolute; left: 5px;" outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('first')" :disabled="page === 1">
          <v-icon>first_page</v-icon>
        </v-btn>
        <v-btn outline fab dark small class="elevation-1" color="accent lighten-2" @click="goToPage('previous')" :disabled="page === 1">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn class="elevation-1 noHover" style="cursor: auto" outline fab dark small color="accent lighten-2">
          <span style="color: #727272">{{ page }}</span>
        </v-btn>
        <v-btn class="elevation-1" outline fab dark small color="accent lighten-2" @click="goToPage('next')" :disabled="lastPage">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>
    <v-dialog
      v-model="deleteTweetConfirmationDialog"
      width="300"
    >
      <v-card class="secondary">
        <v-card-title class="headline">Delete tweet?</v-card-title>
        <v-card-text>
          <v-btn @click="deleteTweet" :loading="deleteLoading">Confirm</v-btn>
          <v-btn @click="deleteTweetConfirmationDialog = false; selectedTweet = null" :disabled="deleteLoading">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<style>
  #tweetsListings .v-list__tile{
    padding-right: 0;
  }
  #tweetsListings .v-btn:focus:before{
    background-color: white !important;
  }
  #tweetsListings .v-btn--disabled{
    background-color: #e0e0e0 !important;
    border: 1px solid #727272;
    -webkit-box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  }
  #tweetsListings .v-btn--disabled:focus:before{
    background-color: #e0e0e0 !important;
  }
  #tweetsListings .v-btn--disabled i{
    color: #727272 !important;
  }
  #tweetsListings div{
    flex: none;
  }
  #tweetsListings .afterHeader{
    width: 100%
  }
</style>
<style scoped>
  .alternateState{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .blurClass{
    filter: blur(5px);
    -webkit-filter: blur(5px);
  }
  .counters{
    flex: none;
    width: calc(9.5% - 10px);
  }
  .actions{
    flex: none !important;
    width: calc(5% - 10px);
    display: flex !important;
    justify-content: center !important;
  }
  .pointer{ cursor: pointer; }
  .noHover:hover{background-color: white !important}
  .noHover:hover:before{background-color: transparent !important}
</style>
<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import { formatTime, formatDate, getLocalDate } from '@/helpers/formatters'
import numeral from 'numeral'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      tweets: [],
      tweetsCount: 0,
      page: 1,
      lastPage: false,
      deleteTweetConfirmationDialog: false,
      selectedTweet: null,
      deleteLoading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    formatDate: formatDate,
    formatTime: formatTime,
    getLocalDate: getLocalDate,
    deleteTweet () {
      this.deleteLoading = true
      axios.all([
        this.$store.dispatch('deleteTweetById', {id: this.selectedTweet, query: '?projectUuid=' + this.getFilters.projectUuid})
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.selectedTweet = null
          this.deleteTweetConfirmationDialog = false
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
        this.getData()
        this.deleteLoading = false
      })).catch((err) => {
        this.deleteLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    backtrack: function (id, type, date) {
      let query = this.$route.query
      query.id = id
      query.type = type
      query.date = date
      query.connections = ['reply', 'retweet', 'quote']
      query.objects = ['tweet']
      this.$router.push({ path: '/backtracker', query: query })
    },
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    goToUser (name) {
      window.open('https://twitter.com/' + name, '_blank')
    },
    goToTweet (id, name) {
      window.open('https://twitter.com/' + name + '/status/' + id, '_blank')
    },
    goToPage (direction) {
      var newPage = this.page
      if (direction === 'first') {
        newPage = 1
      } else if (direction === 'previous') {
        newPage--
      } else if (direction === 'next') {
        newPage++
      }
      if (newPage !== this.page) {
        this.page = newPage
        this.getData()
      }
    },
    getData: function () {
      this.dataState = 'loading'
      let sort = this.options.latest === false || this.options.sortBy === '_user_followers_count' || this.options.sortBy === '_impression_count' || this.options.sortBy === '_created_at' ? this.options.sortBy : this.options.sortBy + '_latest'
      axios.all([
        this.$store.dispatch('getTweetsWithImpressions', this.getQuery({sortBy: sort, order: this.options.orderBy, pageSize: 30, pageNumber: this.page}))
      ]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.tweets = response.data.payload
          if (response.data.payload.length > 0) {
            this.dataState = 'ready'
            this.lastPage = (response.data.payload.length < 30)
          } else {
            this.dataState = 'noData'
            this.lastPage = true
          }
        } else {
          this.dataState = 'error'
          this.lastPage = true
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.lastPage = true
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    },
    options: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.page = 1
          this.getData()
        }
      }
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/listings/TweetsListing.vue